import { __awaiter } from "tslib";
/**
 * 车辆管理-车辆状态查询
 * */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { uniqueArr } from '@/shared/functions';
import Mapping from '@/shared/mapping';
import { dispatch } from '@@/store';
import { notification } from 'antd';
const initData = {
    tableData: [],
    totalNumber: 0,
    pageCurrent: 1,
    pageSize: 20,
    searchData: {},
    exportObjParams: {},
    // 发起付款确认
    showPayConfirm: false,
    price: 0,
    orderId: '',
};
export default createStore({
    state: Object.assign({}, initData),
    effects: {
        // desc 更新表格
        updateTable(index, { state }) {
            const { searchData, pageSize } = state;
            const searchParams = {
                provinceCode: searchData && searchData.provinceCode ? searchData.provinceCode : '',
                cityCode: searchData && searchData.cityCode ? searchData.cityCode : '',
                license: searchData && searchData.license ? searchData.license : '',
                sellerPhone: searchData && searchData.sellerPhone ? searchData.sellerPhone : '',
                vinCode: searchData && searchData.vinCode ? searchData.vinCode : '',
                buyerName: searchData && searchData.buyerName ? searchData.buyerName : '',
                sellerCode: searchData && searchData.sellerCode ? searchData.sellerCode : '',
                buyerPhone: searchData && searchData.buyerPhone ? searchData.buyerPhone : '',
                tradeDateStar: searchData && searchData.startTime ? searchData.startTime : '',
                tradeDateEnd: searchData && searchData.endTime ? searchData.endTime : '',
                buyerTypeCode: searchData && searchData.buyerTypeCode,
                sourceType: searchData && searchData.sourceType,
                confirmReceivables: searchData.confirmReceivables,
                pageSize,
                pageCurrent: index ? index : 1,
            };
            Api.order.getWaitPayCar(searchParams).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    totalNumber: res.totalNumber,
                    pageCurrent: res.currentIndex,
                    exportObjParams: Object.assign(Object.assign({}, searchParams), { totalCount: res.totalNumber, exportType: Mapping.excelExportType.order_wait_pay.value }),
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        // 付款确认窗口
        showPayConfirm(payload) {
            // console.log('record', payload);
            this.SET_STATE({
                price: payload.totalPriceYuanUnit,
                orderId: payload.orderId,
                showPayConfirm: true,
            });
            dispatch.payMoneyModal.getPayRadios({});
        },
        // 申请财务收款窗口
        applyPayMoney(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const params = [];
                params.push(payload.orderId);
                yield Api.order.getApplyPayMoney({ orderIds: JSON.stringify(params) }).then((res) => {
                    if (res) {
                        notification.success({
                            message: '申请财务收款成功',
                        });
                        // this.updateTable(state.pageCurrent);
                    }
                    else {
                        notification.error({
                            message: '申请财务收款失败,请刷新列表',
                        });
                    }
                }).catch((err) => {
                    notification.error({
                        message: '申请付款失败,请刷新列表',
                    });
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_PAYCONFIRM(state) {
            state.showPayConfirm = true;
        },
        HIDE_PAYCONFIRM(state) {
            state.showPayConfirm = false;
        },
    },
});
